import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../axiosInstance";

export const useGetAllUsers = () => {
    const { data, isLoading, error } = useQuery({
      queryKey: ["getAllUsers"],
      queryFn: () =>
        axiosInstance.get("/users").then((res) => res.data),
    });
    console.log("data=>",data)
    console.log("isLoading=>",isLoading)
    console.log("error from useGetAllUsers=>",error)
    return {
      getCurrentPatientData: data,
      isLoading,
      isError: error,
    };
  };

